import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { pdfColors } from './sharedStyles';

const optionTextBase = {
  fontSize: 9,
  flex: 1,
  lineHeight: 1.4,
} as const;

const optionCheckboxBase = {
  width: 16,
  height: 16,
  borderRadius: 9,
  borderWidth: 1,
  marginRight: 10,
  alignItems: 'center' as const,
  justifyContent: 'center' as const,
  flexShrink: 0,
} as const;

const styles = StyleSheet.create({
  optionsContainer: {
    marginTop: 6,
  },
  optionItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 6,
    padding: 8,
    backgroundColor: 'transparent',
    borderRadius: 4,
    borderWidth: 1,
    borderColor: pdfColors.border,
  },
  optionItemSelectedCorrect: {
    backgroundColor: pdfColors.successBg,
  },
  optionItemSelectedIncorrect: {
    backgroundColor: pdfColors.errorBg,
  },
  optionCheckbox: {
    ...optionCheckboxBase,
    borderColor: pdfColors.border,
    backgroundColor: pdfColors.white,
  },
  optionCheckboxSelected: {
    ...optionCheckboxBase,
    borderColor: pdfColors.brand,
    backgroundColor: pdfColors.brand,
  },
  checkmark: {
    fontSize: 11,
    fontFamily: 'Inter-SemiBold',
    color: pdfColors.white,
  },
  optionText: {
    ...optionTextBase,
    color: pdfColors.textLight,
  },
  optionTextSelected: {
    ...optionTextBase,
    color: pdfColors.text,
    fontFamily: 'Inter-SemiBold',
  },
});

interface RadioOption {
  id: string;
  label: string;
  isCorrect: boolean;
}

interface RadioOptionsProps {
  options: RadioOption[];
  selectedIds: string[];
}

function RadioOptions({ options, selectedIds }: RadioOptionsProps): React.ReactElement {
  return (
    <View style={styles.optionsContainer}>
      {options.map((option) => {
        const isSelected = selectedIds.includes(option.id);
        const isCorrect = option.isCorrect;

        const showCheckmark = isSelected;
        const itemStyle =
          isSelected && isCorrect
            ? [styles.optionItem, styles.optionItemSelectedCorrect]
            : isSelected && !isCorrect
              ? [styles.optionItem, styles.optionItemSelectedIncorrect]
              : styles.optionItem;

        const checkboxStyle = isSelected ? styles.optionCheckboxSelected : styles.optionCheckbox;

        return (
          <View key={option.id} style={itemStyle}>
            <View style={checkboxStyle}>
              {showCheckmark ? <Text style={styles.checkmark}>✓</Text> : null}
            </View>
            <Text style={isSelected ? styles.optionTextSelected : styles.optionText}>
              {option.label}
            </Text>
          </View>
        );
      })}
    </View>
  );
}

export default RadioOptions;
